import React, { useEffect } from "react";
import profile1 from "../img/profile1.png";
import profile2 from "../img/profile2.png";

const Section_1 = () => {

  return (
    <div className="js-show-on-scroll grid xl:grid-cols-2 grid-cols-1 items-center xl:px-[100px]">
      <div className=" flex-row xl:p-[4rem] p-4">
        <div className="xl:mt-6 mt-4">
          <p className=" text-[#fe8200] lg:text-[17px] text-[15px]">
            Professional corporate services in Thailand
          </p>
        </div>
        <div className="xl:mt-6 mt-4">
          <h1 className=" font-semibold xl:text-[52px] text-[48px] xl:leading-tight leading-[50px] text-[#00263e]">
            Easily set up, manage & advance your business in Thailand.
          </h1>
        </div>
        <div className="xl:mt-6 mt-4 text-[#00263e]">
          <p className=" xl:text-[24px] text-[20px]">
            Accept provides a{" "}
            <span className=" underline">
              complete suite of corporate services
            </span>{" "}
            for doing business in Thailand & Asia seamlessly. Benefit from the
            big firm experience without the big overheads.
          </p>
        </div>
        <div className=" mt-8 lg:inline-flex items-center justify-center">
          <button className=" min-w-[200px] w-[70%] h-[50px] text-center rounded-full text-white bg-[#fe8200] border-[#fe8200] border-[3px] text-[16px] transition delay-100 ease-in hover:bg-white hover:text-[#fe8200]">
            Schedule a consultation
          </button>
          <div className="flex items-center xl:m-0 mt-6">
            <img
              src={profile1}
              alt="profile1"
              className=" object-fill h-[48px] w-[48px] xl:ml-8"
            />
            <img
              src={profile2}
              alt="profile2"
              className=" object-fill h-[48px] w-[48px] ml-2"
            />
            <p className=" text-[#a3a4a8] font-thin ml-2 text-ellipsis text-[14px]">
              You’ll be talking with one of our experts.
            </p>
          </div>
        </div>
      </div>
      <div className="hidden xl:block animate-fadeIn-3s">
        <img
          src="https://thailand.acclime.com/wp-content/uploads/acclime-dots.svg"
          alt=""
          className="p-8 object-contain w-[80%] "
        />
      </div>
    </div>
  );
};

export default Section_1;
